export default __webpack_public_path__ + "static/media/black-globe.1f820326.png";